import Relay from 'react-relay';

class HoldRequestMutation extends Relay.Mutation {
    getMutation() {
        return Relay.QL`
            mutation {createHoldRequest}
        `;
    }

    getVariables() {
        const {
            itemId,
            userId,
            sellerId,
            vertical
        } = this.props;

        return {
            itemId,
            userId,
            sellerId,
            vertical
        };
    }

    getFatQuery() {
        return Relay.QL`
            fragment on CreateHoldRequestPayload {
                item
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'FIELDS_CHANGE',
            fieldIDs: {item: this.props.itemId}
        }];
    }
}

export default HoldRequestMutation;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/HoldRequestMutation.es.js